import { ILB } from 'components/Loadbalancers/types';

export enum ActionTypes {
  SET_LIST = 'lb: set-list',
}

export interface ILBState {
  list: Array<ILB>;
}
